function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M160.299 189.212l3.685 11.337h11.919l-9.643 7.007 3.684 11.336-9.645-7.006-9.644 7.006 3.684-11.336-9.643-7.007h11.919zm37.101-11.131l3.685 11.338h11.919l-9.643 7.006 3.684 11.337-9.645-7.007-9.644 7.007 3.684-11.337-9.643-7.006h11.919zm37.103-11.13l3.683 11.337h11.919l-9.643 7.007 3.684 11.336-9.643-7.006-9.645 7.006 3.684-11.336-9.643-7.007h11.919zm117.198 22.261l-3.685 11.337h-11.919l9.643 7.007-3.684 11.336 9.645-7.006 9.644 7.006-3.684-11.336 9.643-7.007h-11.919zM314.6 178.081l-3.685 11.338h-11.919l9.643 7.006-3.684 11.337 9.645-7.007 9.644 7.007-3.684-11.337 9.643-7.006h-11.919zm-37.103-11.13l-3.683 11.337h-11.919l9.643 7.007-3.684 11.336 9.643-7.006 9.645 7.006-3.684-11.336 9.643-7.007h-11.92z",
  fill: "#f0f0f0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M285.682 263.414L256 226.312l-14.84 7.421v14.84l-22.261 14.84h-14.84v19.172c21.751 8.808 37.101 30.12 37.101 55.03H256v-14.84l14.84-14.84 14.84 14.84 14.841-14.839v-14.84l14.84-22.261-29.679-7.421z",
  fill: "#ffda44"
});

const SvgKosovo = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKosovo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/kosovo.6c018279.svg";
export { ForwardRef as ReactComponent };